/* eslint-disable */
// @ts-nocheck

import { useEffect } from 'react'
import { DropEvent, FileRejection, useDropzone } from 'react-dropzone'
import { useController, UseControllerProps } from 'react-hook-form'
import { toast } from 'react-toastify'

import useServer from '../../../api/useServerMain'
import SpinnerLoading from '../SpinnerLoading'
import ImageComponent from './Image'

interface DropInterface {
  className?: string
  previewDefault?: string
  onlyPNG?: boolean
  previewHash?: string
  setDisabled?: Function
}

const GenericImageDrop = ({
  className,
  previewDefault,
  onlyPNG,
  previewHash,
  setDisabled,
  ...props
}: DropInterface & UseControllerProps) => {
  const { imgPreview, uploadImg, isFetching } = useServer()
  const { field } = useController(props)

  useEffect(() => {
    imgPreview.length !== 0 && field.onChange(imgPreview[0].id)
  }, [imgPreview])

  const { getRootProps, open, getInputProps } = useDropzone({
    accept: {
      'image/*': onlyPNG ? ['.png'] : ['.png', '.jpeg', '.jpg'],
    },
    //maxSize: 200000,
    onDropRejected: (e: FileRejection[]) =>
      e[0].errors[0].code === 'file-too-large'
        ? toast.error('La imagen excede los 1MB')
        : toast.error('Error al cargar la imagen'),
    onDropAccepted: (file: File[]) => {
      const data = new FormData()
      data.append('file', file[0])
      uploadImg(data)
    },
    noKeyboard: false,
    multiple: false,
  })
  if (isFetching)
    return (
      <div
        className={
          className
            ? className
            : 'flex h-full cursor-pointer items-center justify-center rounded border border-gray-300 p-2'
        }
      >
        <SpinnerLoading />
      </div>
    )

  return (
    <div
      className={`${
        className
          ? className
          : 'flex h-full cursor-pointer items-center justify-center overflow-hidden rounded border border-gray-300 p-2'
      } group relative`}
      {...getRootProps()}
    >
      {imgPreview.length !== 0 || previewDefault ? (
        <div className="absolute left-0 top-0 h-full w-full">
          <ImageComponent
            className="flex h-full w-full items-center justify-center"
            hash={imgPreview[0]?.hash ?? previewHash}
            src={imgPreview[0]?.src ?? previewDefault}
          />
        </div>
      ) : (
        <div className="flex h-full w-full items-center justify-center p-5">
          <svg
            aria-hidden="true"
            className="m-auto h-full rounded-md text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 48 48"
          >
            <path
              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
            />
          </svg>
        </div>
      )}
      <div
        className={`${
          className ? className : ''
        } absolute top-0 hidden h-full w-full items-center justify-center bg-gray-500 opacity-75 group-hover:flex`}
      >
        <div className="flex flex-col items-center p-5 text-center text-sm text-gray-600">
          <div className="relative cursor-pointer rounded font-medium text-gray-50">
            <p onClick={open} onTouchStartCapture={open}>
              Click para cargar archivo
            </p>
            <input hidden {...getInputProps()} />
          </div>
          <p className="text-gray-100">o arrastre uno</p>
          {/* <p className="text-xs text-gray-500">PNG, JPG, GIF hasta 200kB</p>*/}
        </div>
      </div>
    </div>
  )
}

export default GenericImageDrop
